import styled from 'styled-components'

export const AssistiveText = styled.small`
  font-size: 0.75em;
  line-height: 1em;
  letter-spacing: 0.025em;
  color: ${({ theme }) => theme.mediumGrey};
`
